import React from 'react';

import { getMediaUrl } from '../lib/api';

const BlogBlockRenderer = ({ block }) => {
  switch (block.type) {
    case 'heading':
      return <h2 className="blog-block-heading" data-testid={`blog-block-heading-${block.id}`}>{block.text || block.heading}</h2>;
    case 'image':
      return (
        <figure className="blog-block-figure" data-testid={`blog-block-image-${block.id}`}>
          <img src={getMediaUrl(block.media_url)} alt={block.alt_text || block.heading || 'Blog media'} />
          {block.caption && <figcaption>{block.caption}</figcaption>}
        </figure>
      );
    case 'video':
      return (
        <div className="blog-block-video" data-testid={`blog-block-video-${block.id}`}>
          <video src={getMediaUrl(block.media_url)} controls playsInline />
          {block.caption && <p>{block.caption}</p>}
        </div>
      );
    case 'audio':
      return (
        <div className="blog-block-audio" data-testid={`blog-block-audio-${block.id}`}>
          <audio src={getMediaUrl(block.media_url)} controls />
          {block.caption && <p>{block.caption}</p>}
        </div>
      );
    case 'quote':
      return (
        <blockquote className="blog-block-quote" data-testid={`blog-block-quote-${block.id}`}>
          <p>{block.text}</p>
          {block.caption && <cite>{block.caption}</cite>}
        </blockquote>
      );
    case 'list':
      return (
        <div className="blog-block-list" data-testid={`blog-block-list-${block.id}`}>
          {block.heading && <h3>{block.heading}</h3>}
          <ul>
            {block.items?.map((item) => <li key={`${block.id}-${item}`}>{item}</li>)}
          </ul>
        </div>
      );
    case 'cta':
      return (
        <div className="blog-block-cta" data-testid={`blog-block-cta-${block.id}`}>
          {block.heading && <h3>{block.heading}</h3>}
          {block.text && <p>{block.text}</p>}
          {block.button_url && block.button_label && (
            <a href={block.button_url} className="btn btn-primary" data-testid={`blog-block-cta-link-${block.id}`}>
              {block.button_label}
            </a>
          )}
        </div>
      );
    case 'stats':
      return (
        <div className="blog-stats-grid" data-testid={`blog-block-stats-${block.id}`}>
          {block.stats?.map((item) => (
            <div key={`${block.id}-${item.label}`} className="blog-stat-card">
              <strong>{item.value}</strong>
              <span>{item.label}</span>
            </div>
          ))}
        </div>
      );
    case 'paragraph':
    default:
      return (
        <div className="blog-block-paragraph" data-testid={`blog-block-paragraph-${block.id}`}>
          {block.heading && <h3>{block.heading}</h3>}
          <p>{block.text}</p>
        </div>
      );
  }
};

export default BlogBlockRenderer;